import { makeStyles, Theme } from "@material-ui/core/styles";

const useBreadcrumbsStyles = makeStyles((theme: Theme) => ({
	container: {
		marginLeft: "16px",
	},
	pageTitle: {
		color: theme.palette.primary.main,
	},
}));
export default useBreadcrumbsStyles;
